import WorkspaceFilter from "components/workspace/WorkspaceFilter";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { startOfWeek, endOfWeek } from "date-fns";
import DateRangePicker from "shared/inputs/DateRangePicker";
import useUnivWorkspaceFilterHook from "hooks/useUnivWorkspaceFilterHook";
import useNotificationFilter from "hooks/useNotificationFilterHook";
import ProductivitySummary from "./statistics/ProductivitySummary";
import StatisticsSummaryCards from "./statistics/StatisticsSummaryCards";
import TimeSpentChart from "./statistics/TimeSpentChart";
import TimeSpentInCards from "./statistics/TimeSpentInCards";
import { StatisticsContainer } from "./statistics/StatisticsContainer";
import StatisticsDownloadButton from "./statistics/StatisticsDownloadButton";

// Mirrors Users::Statistics::Base::MAX_RANGE_DAYS on the API side.
const MAX_RANGE_DAYS = 365;

function Statistics() {
    const { user_id } = useParams();
    const [dateRange, setDateRange] = useState(
        {
            start: startOfWeek(new Date()),
            end: endOfWeek(new Date())
        }
    )

    // Hooks 
    useNotificationFilter(); // Loads Workspaces for Filter
    const workspace_filter_props = useUnivWorkspaceFilterHook();
    const { unselected_workspace_ids, unselected_organization_ids } = workspace_filter_props;

    return(
        <div className="statistics_page py-4">
            <div className="statistics_page-filters d-md-flex justify-content-between">
                <div className="mb-20px">
                    <DateRangePicker
                        value={dateRange}
                        onChange={setDateRange}
                        maxSpanDays={MAX_RANGE_DAYS}
                    />
                </div>
                <div className="mb-20px d-flex align-items-center gap-3">
                    <WorkspaceFilter {...workspace_filter_props}/>
                    <StatisticsDownloadButton
                        userId={user_id}
                        range={dateRange}
                        excludedWorkspaceIds={unselected_workspace_ids || []}
                        excludedOrganizationIds={unselected_organization_ids || []}
                    />
                </div>
            </div>

            <StatisticsContainer>
                <ProductivitySummary
                    userId={user_id} 
                    range={dateRange} 
                    excludedWorkspaceIds={unselected_workspace_ids || []}
                    excludedOrganizationIds={unselected_organization_ids || []}
                />
                <TimeSpentChart
                    userId={user_id}
                    range={dateRange}
                    excludedWorkspaceIds={unselected_workspace_ids || []}
                    excludedOrganizationIds={unselected_organization_ids || []}
                />
            </StatisticsContainer>

            <StatisticsSummaryCards
                userId={user_id}
                excludedWorkspaceIds={unselected_workspace_ids || []}
                excludedOrganizationIds={unselected_organization_ids || []}
            />

            <TimeSpentInCards
                userId={user_id}
                range={dateRange}
                excludedWorkspaceIds={unselected_workspace_ids || []}
                excludedOrganizationIds={unselected_organization_ids || []}
            />
        </div>
    )
}

export default Statistics;